import { admin as c } from '../styles/adminClasses';
import {
  auditUserLabel,
  formatIcd10AuditSummary,
  icd10ActionLabel,
  parseAuditDetails,
} from '../../../utils/icd10AuditFormat';

function formatTs(ts) {
  if (!ts) return '—';
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return String(ts);
  }
}

function formatDetailsCell(log) {
  if (log.resource === 'icd10') {
    return formatIcd10AuditSummary(log);
  }
  const details = parseAuditDetails(log.details);
  if (details?.performed_by) {
    return typeof details === 'object' ? JSON.stringify(details) : String(details);
  }
  if (!log.details) return '—';
  return typeof log.details === 'string' ? log.details : JSON.stringify(log.details);
}

function formatActionCell(log) {
  if (log.resource === 'icd10') {
    return icd10ActionLabel(log.action);
  }
  return log.action || '—';
}

export default function SystemSettingsView({ auditLogs, loading, onRefresh }) {
  return (
    <div>
      <div className={`${c.panelHeader} mb-3`}>
        <div>
          <h2 className={c.sectionTitle}>System settings</h2>
          <p className={c.sectionDesc}>Audit trail and platform configuration overview.</p>
        </div>
        <button type="button" className={c.btnSecondary} onClick={onRefresh}>
          Refresh logs
        </button>
      </div>

      <div className={`${c.sectionPanel} mb-3`}>
        <h3 className={c.cardTitle}>Configuration</h3>
        <ul className="mt-3 space-y-2 text-sm text-emerald-50">
          <li>
            System administrators operate nationally — they manage all state hospitals and clinics,
            including staff onboarding, transfers, and facility registration.
          </li>
          <li>Employee lifecycle: accounts are inactivated, never deleted from the system.</li>
          <li>Facilities: hospital, clinic, and health center types are supported nationally.</li>
          <li>National clinic and hospital prices are managed from Billing Prices, with optional per-facility overrides and full change history.</li>
          <li>Billing shifts and payment collection remain managed on-site by billing clerks and the revenue office.</li>
        </ul>
      </div>

      <div className={c.sectionPanel}>
        <h3 className={`${c.cardTitle} mb-3`}>Audit logs</h3>
        <div className={`${c.tableWrap} border-0 bg-white/10 shadow-none`}>
          <table className={c.table}>
          <thead>
            <tr>
              <th className={c.th}>Time</th>
              <th className={c.th}>User</th>
              <th className={c.th}>Action</th>
              <th className={c.th}>Resource</th>
              <th className={c.th}>Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/10">
            {loading ? (
              <tr>
                <td colSpan={5} className={c.tdMuted}>
                  Loading audit logs…
                </td>
              </tr>
            ) : auditLogs.length === 0 ? (
              <tr>
                <td colSpan={5} className={c.tdMuted}>
                  No audit entries yet.
                </td>
              </tr>
            ) : (
              auditLogs.map((log) => (
                <tr key={log.id}>
                  <td className={`${c.td} whitespace-nowrap text-xs`}>{formatTs(log.timestamp)}</td>
                  <td className={c.td}>{auditUserLabel(log)}</td>
                  <td className={c.td}>{formatActionCell(log)}</td>
                  <td className={c.td}>{log.resource}</td>
                  <td className={`${c.td} text-xs`}>{formatDetailsCell(log)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
